/* unplugin-vue-components disabled */import script from "./RankingChart.vue?vue&type=script&setup=true&lang=js"
export * from "./RankingChart.vue?vue&type=script&setup=true&lang=js"

import "./RankingChart.vue?vue&type=style&index=0&id=768e619a&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-768e619a"]])

export default __exports__